import uuid from 'uuidv4';
import { Block, cloneBlock } from '@chameleoncreator/creator-app';

export const createBlock = (
  type: string,
  children: Block[] = [],
  extra: any = {}
): Block => {
  return {
    id: uuid(),
    type: type,
    props: extra.props,
    meta: extra.meta,
    animator: extra.animator,
    children: children,
  };
};

const reorder = (list: any[], startIndex: number, endIndex: number): any[] => {
  const reordered = [...list];
  const [removed] = reordered.splice(startIndex, 1);
  reordered.splice(endIndex, 0, removed);

  return reordered;
};

export const reorderChildren = (
  block: Block,
  startIndex: number,
  endIndex: number
): Block => {
  if (Array.isArray(block.children)) {
    const newBlock = cloneBlock(block);
    newBlock.children = reorder(block.children, startIndex, endIndex);
    return newBlock;
  }
  return block;
};
